import { Observable } from 'rxjs/Observable'
import { DataService } from 'core/data/service'

export class CepService extends DataService {

  constructor() {
    super()
  }

  changeCep(cep) {

    console.log('cep enviado', cep)
    const options = {
      method: 'POST',
      url: '/endereco/alterar-cep/' + Number(cep.cepNavegacao)
    }

    return Observable
              .fromPromise(super.request(options));
  }

  getCepNavegacaoGeolocation (lat, lng) {
    if (lat == null || lng == null) return {status : 400};
    let latlng = lat +","+ lng;

    /*let url = "https://apiproxy.grupodimedservices.com.br/googlemapsapis/maps/api/geocode/json";
    let params = {sensor: false, latlng: latlng, key: "AIzaSyD_L9PTJ0YLTRxlsziEHCODcugQsgUFQfo"};*/

    let url = "https://maps.google.com/maps/api/geocode/json";//DEV
    let params =  {sensor: false, latlng: latlng, key: "AIzaSyD_L9PTJ0YLTRxlsziEHCODcugQsgUFQfo"}; //DEV

      const options = {
        method: "GET",
        url: url,
        params: params,
        responseType: "json",
    }

    return Observable.fromPromise(super.request(options));
  }

  setValueCokieByName (cname, cvalue) {
      let min = this.getValueCookieByName("LojaVirtualPanvelMinutesTimeoutCepExpired");
      if (isNaN(min)) min = 1440; //1 dia
      let t = parseInt(min) * 1000;
      let d = new Date();
      d.setTime(d.getTime() + (t));
      let expires = "expires="+ d.toUTCString();
      return document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  }

  getValueCookieByName (cname) {
      let name = cname + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let ca = decodedCookie.split(';');
      for (let i = 0; i <ca.length; i++) {
          let c = ca[i];

          while (c.charAt(0) == ' ') {
              c = c.substring(1);
          }

          if (c.indexOf(name) == 0) return c.substring(name.length, c.length);
      }
      return "";
  }

}






// WEBPACK FOOTER //
// ./src/main/webapp/assets/js/components/cep-navigation/cep.service.js